/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectsControllerAddViewerMutationRequest, ProjectsControllerAddViewerMutationResponse, ProjectsControllerAddViewerPathParams } from "../../models/projectsController/ProjectsControllerAddViewer";

function getProjectsControllerAddViewerUrl(id: ProjectsControllerAddViewerPathParams["id"]) {
  const res = { method: 'POST', url: `/api/v1/projects/${id}/relationships/viewers` as const }  
  return res
}

/**
 * @summary Add the current principal as a sample project viewer
 * {@link /api/v1/projects/:id/relationships/viewers}
 */
export async function projectsControllerAddViewer(id: ProjectsControllerAddViewerPathParams["id"], data: ProjectsControllerAddViewerMutationRequest, config: Partial<RequestConfig<ProjectsControllerAddViewerMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ProjectsControllerAddViewerMutationResponse, ResponseErrorConfig<Error>, ProjectsControllerAddViewerMutationRequest>({ method : "POST", url : getProjectsControllerAddViewerUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}